import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

// app routes (pages)
import Home from './Routes/Home/Home';
import QuoteCreator from './Routes/QuoteCreator/QuoteCreator';
import QuoteEditor from './Routes/QuoteEditor/QuoteEditor';
import QuoteDatabase from './Routes/QuoteDatabase/QuoteDatabase';
import SalesOrderCreator from './Routes/SalesOrderCreator/SalesOrderCreator';
import SalesOrderDatabase from './Routes/SalesOrderDatabase/SalesOrderDatabase';
import LiveQuote from './Routes/LiveQuote/LiveQuote';
import ImageUploader from './Routes/ImageUploader/ImageUploader';
import PageNotFound from './Routes/PageNotFound/PageNotFound';

// custom components
import LoginScreen from './Components/LoginScreen/LoginScreen';
import AppShell from './Components/AppShell/AppShell';
import AppShellCustomer from './Components/AppShellCustomer/AppShellCustomer';

import './App.css';

// import { Button } from 'carbon-components-react';

function App() {
	const { loginWithRedirect, logout, user, isAuthenticated, getAccessTokenSilently } = useAuth0();

	// location hook
	let urlLocation = window.location;

	// STATE
	// auth info for all user management needs
	const [token, setToken] = useState(null);
	// console.log("USER INFO", user, isAuthenticated); //DEBUG

	const [quoteItems, setQuoteItems] = useState([]);
	const [quoteToEdit, setQuoteToEdit] = useState(null);
	const [salesOrderToEdit, setSalesOrderToEdit] = useState(null);

	useEffect(() => {
		// define fetch token fx
		async function fetchToken() {
			if (isAuthenticated) {
				const token = await getAccessTokenSilently();
				// const token = null
				setToken(token);
			}
		}
		// call functions
		fetchToken();
		return () => {};
	}, [token, user, getAccessTokenSilently]);

	//TODO proposed fix for the login shit appearing after
	//every reload is to put timed reload
	// OR even better to make loading state variable that tracks when auth Request
	// is loading and if it fails then only then show login page :p

	if (!isAuthenticated) {
		//exception for the live quote page
		if (urlLocation.pathname.includes('/quote/') === true) {
			return (
				<Router>
					<AppShellCustomer isAuthenticated={isAuthenticated}>
						<Switch>
							<Route exact path="/quote/:id">
								<LiveQuote />
							</Route>
						</Switch>
					</AppShellCustomer>
				</Router>
			);
		} else {
			return <LoginScreen loginFx={loginWithRedirect} />;
		}

		//user not logged in, show login screen
		return <LoginScreen loginFx={loginWithRedirect} />;
	}

	// user IS logged in, render the app
	return (
		<Router>
			<AppShell user={user} logout={logout}>
				<Switch>
					<Route exact path="/">
						<Home quoteToEdit={quoteToEdit} setQuoteToEdit={setQuoteToEdit} quoteItems={quoteItems} setQuoteItems={setQuoteItems} token={token} />
					</Route>
					<Route exact path="/quote-creator">
						<QuoteCreator quoteItems={quoteItems} user={user} token={token} />
					</Route>
					<Route exact path="/quote-editor">
						<QuoteEditor quoteToEdit={quoteToEdit} setQuoteToEdit={setQuoteToEdit} user={user} token={token} />
					</Route>
					<Route exact path="/quote-database">
						<QuoteDatabase setSalesOrderToEdit={setSalesOrderToEdit} quoteToEdit={quoteToEdit} setQuoteToEdit={setQuoteToEdit} token={token} />
					</Route>
					<Route exact path="/sales-order-database">
						<SalesOrderDatabase token={token} />
					</Route>
					<Route exact path="/sales-order-creator">
						<SalesOrderCreator salesOrderToEdit={salesOrderToEdit} setSalesOrderToEdit={setSalesOrderToEdit} user={user} token={token} />
					</Route>
					<Route exact path="/quote/:id">
						<LiveQuote token={token} />
					</Route>
					<Route exact path="/image-management">
						<ImageUploader token={token} />
					</Route>
					<Route>
						<PageNotFound />
					</Route>
				</Switch>
			</AppShell>

			{/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}
		</Router>
	);
}

export default App;
